import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import heroImage from "@assets/images/supplier-vendor-hero.svg";
import macbook from "@assets/images/macbook.svg";

import buildingIcon from "@assets/icons/building-2-fill.svg";
import mailIcon from "@assets/icons/mail-fill.svg";
import phoneIcon from "@assets/icons/phone-fill.svg";
import shieldIcon from "@assets/images/shield.svg";
import Contact from "../components/contact";
import {
  conducts,
  criteria,
  evaluationSteps,
  invitations,
  notifications,
  statuses,
  uploadCenters,
  vendorCategories,
} from "../data";

import MultiStepForm from "../components/MultiStepForm";
import { HeroButton } from "../components/button";

const heroData = {
  title: "Partner With GASIS Through Our Certified Vendor Program",
  description:
    "This portal allows suppliers, contractors, manufacturers, and service providers to register, upload compliance documents, apply for pre-qualification, and receive tender invitations.",
  image: heroImage,
  buttonText: "Register as a Vendor",
  buttonOnclick: () => openMailto({ subject: "Supplier Registration Inquiry" }),
  footerText:
    "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business. ",
  footerButtonText: "Report an Emergency Online",
  footerButtonOnclick: () => openMailto({ subject: "Emergency Report", body: "Emergency Type:\nLocation:\nDescription:\n" }),
};

export default function SupplierAndVendor() {
  return (
    <main className="bg-white">
      <Hero data={heroData} />

      {/* Vendor Categories section  */}
      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[120px] px-4 md:px-6 lg:px-8">
        <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Vendor Categories Accepted
        </h1>
        <h2 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left md:text-center leading-relaxed">
          We work with qualified vendors across:{" "}
        </h2>
        <div className="max-w-[1400px] mt-6 md:mt-8 lg:mt-12 xl:mt-16 mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
            {vendorCategories.map((data, i) => (
              <div
                key={i}
                className="w-full min-h-[174px] border border-[#62636C33] rounded-[24px] p-[24px]"
              >
                <span className="bg-[#F03813] text-[16px] md:text-[18px] lg:text-[20px] font-semibold text-white size-[44px] rounded-full flex items-center justify-center">
                  {data.id}
                </span>

                <p className="mt-[24px] text-[#090D2C] leading-normal text-[20px] md:text-[22px] lg:text-[24px] font-medium">
                  {data.title}{" "}
                </p>
              </div>
            ))}
          </div>

          <div className="w-full bg-[#FEF6F4] flex flex-col sm:flex-row items-center justify-center gap-[12px] h-auto sm:h-[76px] border border-[#F03813] rounded-[16px] mt-[48px] p-4 sm:p-0">
            <img src={shieldIcon} alt="" className="flex-shrink-0" />
            <p className="text-[#1E1F24] text-[16px] md:text-[18px] lg:text-[20px] xl:text-[28px] font-normal text-center sm:text-left">
              Vendors must meet GASIS and regulatory standards.
            </p>
          </div>
        </div>
      </section>

      {/* Requests & Verification section */}

      <section className="mt-12 bg-[#F1F1F1] md:mt-16 lg:mt-24 pt-12 md:pt-16 lg:pt-20 xl:pt-[100px] pb-16 md:pb-20 lg:pb-24 xl:pb-[120px] xl:mt-[120px] px-4 md:px-6 lg:px-8">
        <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Requests & Verification{" "}
        </h1>
        <h2 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left md:text-center leading-relaxed">
          Investors or stakeholders may request official copies of the above
          documents.{" "}
        </h2>
        <div className="max-w-[1400px] mt-6 md:mt-8 lg:mt-12 xl:mt-16 mx-auto">
          <MultiStepForm />
        </div>
      </section>

      {/*           Evaluation Criteria section */}

      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[120px]  px-4 md:px-6 lg:px-8">
        <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Evaluation Criteria{" "}
        </h1>
        <h2 className="text-[#62636C] max-w-[966px] mx-auto text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left md:text-center leading-relaxed">
          Once registered, vendors may apply for pre-qualification to receive
          RFQs through our four-stage evaluation process{" "}
        </h2>
        <div className="max-w-[1400px] mt-6 md:mt-8 lg:mt-12 xl:mt-16 mx-auto">
          <div className="w-full min-h-[191px] bg-[#F1F1F1] rounded-[16px] py-[24px] px-[24px] md:px-[48px]">
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636C] font-semibold">
              Requirements:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 md:gap-y-6 mt-4 md:mt-6">
              {criteria.map((data, i) => (
                <div key={i} className="flex items-center gap-[12px]">
                  <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                  <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                    {data}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mt-[32px] md:mt-[45px]">
            {evaluationSteps.map((data, i) => (
              <div
                key={i}
                className="w-full min-h-[192px] p-[20px] md:p-[24px] rounded-[24px] border border-[#62636C33]"
              >
                <p className="text-[12px] md:text-[14px] font-normal text-[#F03813]">
                  Stage {data.stage}
                </p>
                <p className="text-[#090D2C] text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] font-semibold mt-[12px]">
                  {data.title}
                </p>
                <p className="text-[#0A0E2EBF] text-[16px] md:text-[18px] lg:text-[20px] font-normal mt-[20px] md:mt-[24px]">
                  {data.subtitle}
                </p>
              </div>
            ))}
          </div>

          <div className="w-full  mt-[48px] md:mt-[64px] flex justify-center">
            <HeroButton
              title="Apply for Pre-Qualification"
              onClick={() => openMailto({ subject: "Supplier Registration Inquiry" })}
            />
          </div>
        </div>
      </section>

      <section className="mt-12 bg-[#F1F1F1] md:mt-16 lg:mt-24 pt-12 md:pt-16 lg:pt-20 xl:pt-[100px] pb-16 md:pb-20 lg:pb-24 xl:pb-[120px] xl:mt-[120px] px-4 md:px-6 lg:px-8">
        <div className="max-w-[1400px]  mx-auto">
          <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
            Upload Center{" "}
          </h1>

          <div className="mt-[28px]">
            <p className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] font-normal leading-[32px] text-left md:text-center">
              Vendors can upload new or renewed documents such as:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-3 md:gap-y-6 mt-4 md:mt-6">
              {uploadCenters.map((data, i) => (
                <div key={i} className="flex items-center gap-[12px]">
                  <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                  <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                    {data}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-[48px] flex justify-center">
            <HeroButton title="Upload Documents" onClick={() => openMailto({ subject: "Document Upload Request" })} />
          </div>

          <h1 className="text-[28px] mt-[60px] md:mt-[80px] lg:mt-[100px] xl:mt-[120px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left ">
            Tender Invitations & Notifications{" "}
          </h1>
          <div className="mt-[30px] flex flex-col xl:flex-row xl:items-center xl:justify-between gap-8 xl:gap-0">
            <div className="flex-1">
              <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636C] font-semibold leading-[32px] text-left  xl:text-left">
                Once approved, suppliers may receive:
              </p>
              <div className="grid grid-cols-1 gap-y-3 md:gap-y-6 mt-4 md:mt-6">
                {invitations.map((data, i) => (
                  <div key={i} className="flex items-center gap-[12px]">
                    <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                    <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                      {data}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full xl:w-[759px] min-h-[213px] bg-[#FEF6F4] border border-[#F24D2B] rounded-[16px] p-[20px] md:p-[30px] xl:p-[40px]">
              <p className="text-[20px] md:text-[24px] lg:text-[28px] xl:text-[32px] text-[#62636C] leading-[32px] font-semibold">
                Notifications are sent via:
              </p>
              <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-0 mt-[20px] md:mt-[30px] xl:mt-[40px]">
                {notifications.map((data, i) => (
                  <div key={i} className="flex items-center gap-[12px]">
                    <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                    <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                      {data}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-12 md:mt-16 lg:mt-24 xl:mt-[120px] px-4 md:px-6 lg:px-8">
        <div className="max-w-[1400px] mt-6 md:mt-8 lg:mt-12 xl:mt-16 mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
            <div className="w-full lg:flex-1 ">
              <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left  lg:text-left">
                Track Application Status{" "}
              </h1>
              <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C] text-left  lg:text-left mt-3 md:mt-4">
                Vendors can track:{" "}
              </p>
              <div className="grid grid-cols-1  gap-y-3 md:gap-y-6 mt-4 md:mt-6">
                {statuses.map((data, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-[12px] justify-start  lg:justify-start"
                  >
                    <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                    <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                      {data}
                    </p>
                  </div>
                ))}
              </div>
              <div className="mt-[32px] md:mt-[48px] flex justify-center lg:justify-start">
                <HeroButton title="Track My Status" onClick={() => openMailto({ subject: "Application Status Inquiry" })} />
              </div>
            </div>
            <div className="w-full lg:max-w-[647px] aspect-[647/552] pt-8 md:pt-10 lg:pt-12 xl:pt-[67px] pl-4 md:pl-5 lg:pl-6 xl:pl-[35px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] bg-[#F24D2B] flex items-start justify-start overflow-hidden ">
              <img
                src={macbook}
                alt=""
                className="w-full h-full object-contain object-left-top"
              />
            </div>
          </div>

          <div className="mt-12 md:mt-16 lg:mt-24 xl:mt-[120px]">
            <h1 className="text-[28px] md:text-[36px] lg:text-[46px] xl:text-[54px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left ">
              Vendor Code of Conduct{" "}
            </h1>

            <div className="mt-[24px] md:mt-[32px] lg:mt-[40px]">
              <p className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] font-normal leading-[32px] text-left ">
                All suppliers must comply with:{" "}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 md:gap-y-6 mt-4 md:mt-6">
                {conducts.map((data, i) => (
                  <div key={i} className="flex items-center gap-[12px]">
                    <span className="block size-[12px] rounded-full bg-[#62636C] flex-shrink-0"></span>
                    <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C]">
                      {data}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <div className="mx-auto py-12 md:py-16 lg:py-20 xl:py-[100px] px-4 md:px-6 lg:px-8">
        <Contact
          title="Need Help with your Bill or Account"
          subtitle="Call our 24/7 Emergency Line: 800-GASIS (42747) or report a concern via our Online Safety Form."
          cardTitle="Book Consultation"
          contactDetails={[
            { title: "help@gasis.ae", icon: mailIcon },
            { title: "Support (8 AM – 8 PM)", icon: phoneIcon },
            { title: "Sunday – Thursday (8 AM – 6 PM)", icon: buildingIcon },
          ]}
        />
      </div>
    </main>
  );
}
